
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { supabase } from "../cloudflareClient";
import ENTRELOGO from "../images/ENTRELOGO.png";

import {
  AiOutlineHistory,
  AiOutlineLogout,
  AiOutlineSafety,
  AiOutlineMore,
  AiOutlineClose,
  AiOutlineUser,
  AiOutlineFileText,
  AiOutlineGlobal,
  AiOutlineDownload,
} from "react-icons/ai";

import "./Header.css";

function Header({ activePage }) {
  const history = useHistory();

  const [isAdminUser, setIsAdminUser] = useState(false);
  const [userName, setUserName] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [installPrompt, setInstallPrompt] = useState(null);
  const [isAppInstalled, setIsAppInstalled] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const checkRole = async () => {
      try {
        const {
          data: { session },
        } = await supabase.auth.getSession();

        if (!session?.user) return;

        const user = session.user;
        const userEmail = (user.email || "").toLowerCase();

        if (isMounted) {
          setUserName(
            user.user_metadata?.name ||
              user.email ||
              "Utilisateur"
          );
        }

        if (
          userEmail.includes("admin") ||
          user.user_metadata?.role === "admin"
        ) {
          if (isMounted) setIsAdminUser(true);
        }

        const { data: profileResult } =
          await supabase.auth.getProfile();

        const data = profileResult?.profile;

        if (data && isMounted) {
          setUserName(
            data.name ||
              user.user_metadata?.name ||
              user.email ||
              "Utilisateur"
          );

          if (
            data.role === "admin" ||
            data.is_admin === true
          ) {
            setIsAdminUser(true);
          }
        }
      } catch (e) {
        // Silently ignore
      }
    };

    checkRole();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const handleInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };

    const handleAppInstalled = () => {
      setInstallPrompt(null);
      setIsAppInstalled(true);
    };

    setIsAppInstalled(
      window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true
    );
    window.addEventListener("beforeinstallprompt", handleInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleLogout = async () => {
    setMenuOpen(false);
    await supabase.auth.signOut();
    history.push("/");
  };

  const navigate = (path) => {
    setMenuOpen(false);
    history.push(path);
  };

  const handleInstall = async () => {
    if (!installPrompt) {
      setMenuOpen(false);
      window.alert(
        "Pour installer l'application, ouvrez le menu de votre navigateur puis choisissez « Ajouter à l'écran d'accueil »."
      );
      return;
    }

    installPrompt.prompt();
    await installPrompt.userChoice;
    setInstallPrompt(null);
    setMenuOpen(false);
  };

  return (
    <header className="app-header">

      {/* Logo */}
      <div
        className="header-brand"
        onClick={() => navigate("/facteur-editeur")}
        title="Aller à la création de facture"
      >
        <img
          src={ENTRELOGO}
          alt="Auto Entrepreneur Logo"
          className="brand-logo"
        />
      </div>

      {/* User */}
      <div className="header-user">
        <div className="header-user-avatar">
          <AiOutlineUser />
        </div>

        <div className="header-user-info">
          <span>Connecté en tant que</span>
          <strong>{userName || "Utilisateur"}</strong>
        </div>
      </div>

      {/* Menu Button */}
      <button
        type="button"
        className={`menu-toggle ${menuOpen ? "menu-toggle-active" : ""}`}
        aria-label={
          menuOpen ? "Fermer le menu" : "Ouvrir le menu"
        }
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((open) => !open)}
      >
        {menuOpen ? (
          <AiOutlineClose />
        ) : (
          <AiOutlineMore />
        )}
      </button>

      {/* Dropdown Menu */}
      {menuOpen && (
        <>
          <div
            className="menu-overlay"
            onClick={() => setMenuOpen(false)}
          />

          <div className="header-menu">

        

            {/* User */}
            {/* <div className="menu-account">
              <div className="menu-account-icon">
                <AiOutlineUser />
              </div>

              <div>
                <span>Compte connecté</span>
                <strong>
                  {userName || "Utilisateur"}
                </strong>
              </div>
            </div> */}

            {/* Navigation */}
            <div className="menu-items">

              <button
                type="button"
                className={`menu-item menu-item-history ${
                  activePage === "historique"
                    ? "menu-item-active"
                    : ""
                }`}
                onClick={() => navigate("/historique")}
              >
                <div className="menu-item-icon">
                  <AiOutlineHistory />
                </div>

                <div className="menu-item-content">
                  <strong>Historique</strong>
                  {/* <span>
                    Consulter vos factures
                  </span> */}
                </div>
              </button>

              {!isAppInstalled && (
                <button
                  type="button"
                  className="menu-item menu-item-install"
                  onClick={handleInstall}
                >
                  <div className="menu-item-icon">
                    <AiOutlineDownload />
                  </div>

                  <div className="menu-item-content">
                    <strong>Installer l'application</strong>
                    <span>Ajouter sur votre téléphone</span>
                  </div>
                </button>
              )}

              <button
                type="button"
                className={`menu-item menu-item-invoice ${
                  activePage === "facteur-editeur"
                    ? "menu-item-active"
                    : ""
                }`}
                onClick={() =>
                  navigate("/facteur-editeur")
                }
              >
                <div className="menu-item-icon">
                  <AiOutlineFileText />
                </div>

                <div className="menu-item-content">
                  <strong>Nouvelle facture</strong>
                </div>
              </button>


              <a
                className="menu-item menu-item-web"
                href="https://rn.ae.gov.ma/login"
                target="_blank"
                rel="noreferrer"
                onClick={() => setMenuOpen(false)}
              >
                <div className="menu-item-icon">
                  <AiOutlineGlobal />
                </div>

                <div className="menu-item-content">
                  <strong>https://rn.ae.gov.ma</strong>
                </div>
              </a>



              {(isAdminUser || activePage === "admin") && (
                <button
                  type="button"
                  className={`menu-item menu-item-admin menu-item-admin-color ${
                    activePage === "admin"
                      ? "menu-item-active"
                      : ""
                  }`}
                  onClick={() => navigate("/admin")}
                >
                  <div className="menu-item-icon">
                    <AiOutlineSafety />
                  </div>

                  <div className="menu-item-content">
                    <strong>Administration</strong>
                    <span>
                      Gérer l'application
                    </span>
                  </div>
                </button>
              )}

            </div>

            {/* Logout */}
            <div className="menu-footer">
              <button
                type="button"
                className="menu-logout"
                onClick={handleLogout}
              >
                <AiOutlineLogout font-size="1.5rem" />
                <span>Déconnexion</span>
              </button>
            </div>

          </div>
        </>
      )}

    </header>
  );
}

export default Header;

